import { useEffect } from "react";

const TaskVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);


  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=9935f26e6074a509446b9b29aa07d409&source=embed&photo_id=105248326&endOn="
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};



export default TaskVideo;
